import { AgmCoreModule } from '@agm/core';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AppRoutingModule } from './app-routing.module';
import { SafeHtmlPipe } from 'src/app/pipe/safe.pipe';
import { UniquePipe, UniqueLanguagePipe } from 'src/app/pipe/unique.pipe';
import { AppComponent } from './app.component';
import { LazyLoadScriptService } from './lazy_load_script_service';
import { FaqComponent } from './pages/faq/faq.component';
import { ResourcesComponent } from './pages/resources/resources.component';
import { trainingComponent } from './pages/training/training.component';
import { salaryScaleComponent } from './pages/salaryScale/salaryScale.component';
//import { ModalModule } from 'ngx-bootstrap/modal';
import { FooterComponent } from './pages/footer/footer.component';
import { HeaderComponent } from './pages/header/header.component';
import { HomeComponent } from './pages/home/home.component';
//import { SafePipe } from './pipe/safe.pipe';
import { PageService } from './services';
import { contact_usComponent } from './pages/contact_us/contact_us.component';
import { ContactFormComponent } from './pages/contact-form/contact-form.component';
import { NgxCaptchaModule } from 'ngx-captcha';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    //SafePipe,
    SafeHtmlPipe,
    UniquePipe,
    UniqueLanguagePipe,
    FaqComponent,
    ResourcesComponent,
    trainingComponent,
    salaryScaleComponent,
    contact_usComponent,
    ContactFormComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    BrowserAnimationsModule,
    CarouselModule,
    ModalModule.forRoot(),
    NgbModule,
    PaginationModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: ''
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient],
      }
    }),
  ],
  exports: [
    TranslateModule
  ],
  providers: [LazyLoadScriptService, PageService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})


export class AppModule { }

// export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
//   return new TranslateHttpLoader(http);
// }
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}